var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-3"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.planTypeText)+" expirou!")])])],1),_c('b-row',[_c('b-col',[_c('subscribe',{on:{"stored":function($event){return _vm.$router.push('/dashboard')}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }